import React from 'react';
import { useEnochFilterContext } from './context';
import { useEnochGeneralReport } from '../../../query/enoch';

import { Statistic, Card, Row, Col, Spin } from 'antd';
import EnochProfileConnectionStats from './EnochProfileConnectionStats';

export default function GeneralEnochReport() {
  const filter = useEnochFilterContext();
  const { data, isLoading } = useEnochGeneralReport(filter);
  return (
    <Spin spinning={isLoading} tip="Loading...">
      <Row gutter={16}>
        <Col span={4}>
          <Card>
            <Statistic
              precision={0}
              suffix="emails"
              title="Moved to Inbox / Total Spam"
              value={`${data?.numOfSpamsMoved || 0} / ${data?.numOfSpams || 0}`}
              valueStyle={{
                color: '#0047AB',
              }}
            />
          </Card>
        </Col>

        <Col span={5}>
          <Card>
            <Statistic
              precision={0}
              suffix="emails"
              title="Unmarked as Promotion / Total Promotions"
              value={`${data?.numOfPromotionsMoved ||
                0} / ${data?.numOfPromotions || 0}`}
              valueStyle={{
                color: '#0047AB',
              }}
            />
          </Card>
        </Col>

        <Col span={5}>
          <Card>
            <Statistic
              precision={0}
              suffix="emails"
              title="Marked as Important / Total Unimportant"
              value={`${data?.numOfUnimportantMoved ||
                0} / ${data?.numOfUnimportant || 0}`}
              valueStyle={{
                color: '#0047AB',
              }}
            />
          </Card>
        </Col>

        <Col span={5}>
          <Card>
            <Statistic
              precision={0}
              suffix="emails"
              title="Open and Replied / Total Inboxes"
              value={`${data?.numOfInboxesReplied ||
                0} / ${data?.numOfInboxes || 0}`}
              valueStyle={{
                color: '#0047AB',
              }}
            />
          </Card>
        </Col>

        <Col span={5}>
          <EnochProfileConnectionStats />
        </Col>
      </Row>
    </Spin>
  );
}
